(function () {

    "use strict";

    angular
        .module('components')
        .component('hNunjucks', {
            controller: HNunjucksComponent,
            controllerAs: 'hNunjucksComponent',
            bindings: {
                data: '<',
                refreshView: '<',
                templateUrl: '<',
                onViewUpdated: '&',
                minify: '<',
                async: '<'
            },
            templateUrl: '../hmodules/components/h-nunjucks/h-nunjucks.component.html'
        });

    HNunjucksComponent.$inject = ['$element', 'DispatcherServices'];

    function HNunjucksComponent($element, DispatcherServices) {

        var self = this;
        var _nunjucks = DispatcherServices.getNunjucks();

        self.$onChanges = function () {
            updateView();
        };

        self.$doCheck = function () {
        };

        var updateView = function () {
            if (self.templateUrl) {
                if (self.async) {
                    _nunjucks.render(self.templateUrl, { data: self.data }, function (err, html) {
                        if (err) {
                            console.error(err);
                            return;
                        }
                        if (self.minify) {
                            html = Utils.minifyHtml(html);
                        }

                        var elm = $(html);
                        $element.find(".h-nunjucks").html(elm);
                        self.onViewUpdated({ 'element': elm });
                    });
                }
                else {
                    var html = _nunjucks.render(self.templateUrl, { data: self.data });
                    if (self.minify) {
                        html = Utils.minifyHtml(html);
                    }
                    var elm = $(html);
                    $element.find(".h-nunjucks").html(elm);
                    self.onViewUpdated({ 'element': elm });
                }

            }
        }
    }
})();